import { ComplianceLevel } from './levels';

export type ComplianceFlags = { v1: boolean; v2: boolean };

/**
 * The single source of compliance-level precedence: a higher level wins.
 * This is the only if-chain over compliance flags in the app.
 */
export const resolveComplianceLevel = ({
  v1,
  v2,
}: ComplianceFlags): ComplianceLevel => {
  if (v2) return ComplianceLevel.V2;
  if (v1) return ComplianceLevel.V1;
  return ComplianceLevel.LEGACY;
};
